import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-e5c7268e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = { class: "content text-center rounded-lg shadow-xl bg-white" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center p-3 md:p-4",
  style: {"background-color":"#3a3a3a"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "hy3d-logo",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "px-7 pt-7 mb-5 md:px-12 md:pt-12 md:pb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-4xl md:text-5xl font-bold",
  style: {"color":"#666"}
}, "견적서를 등록 했습니다.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-2",
  style: {"color":"#aaa"}
}, "전문가가 확인 후 바로 연락드리겠습니다.", -1))
const _hoisted_7 = { class: "mt-12 px-3 md:px-5" }
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-desc" }, "출력 비용", -1))
const _hoisted_10 = { class: "text-xl font-semibold" }
const _hoisted_11 = { class: "flex justify-between mt-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-desc" }, "배송 비용", -1))
const _hoisted_13 = { class: "text-xl font-semibold" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "border-t border-line mt-5 mb-5" })
], -1))
const _hoisted_15 = { class: "flex justify-between" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-desc" }, "부가세 V.A.T (예상)", -1))
const _hoisted_17 = { class: "text-xl font-semibold" }
const _hoisted_18 = { class: "flex justify-between mt-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "총 비용 (예상)", -1))
const _hoisted_20 = { class: "text-xl font-semibold" }
const _hoisted_21 = {
  class: "mt-12 p-4 rounded-lg text-xl md:p-5 md:text-2xl font-bold",
  style: {"background-color":"#515151","color":"#e7e7e7"}
}
const _hoisted_22 = { class: "flex justify-between mt-8 w-full" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flex fi fi-rs-print text-xl" }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "견적서 출력")
], -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.numberToComma(_ctx.estimate.modelCost ? _ctx.estimate.modelCost : 0)) + " 원", 1)
          ]),
          _createElementVNode("li", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.shippingCost) + " 원", 1)
          ]),
          _hoisted_14,
          _createElementVNode("li", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.vat) + " 원", 1)
          ]),
          _createElementVNode("li", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.totalCost) + " 원", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, "No. " + _toDisplayString(_ctx.estimate.id), 1),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            class: "cs-btn cs-btn-default cs-pd-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrint && _ctx.onPrint(...args)))
          }, _hoisted_24),
          _createElementVNode("button", {
            class: "cs-btn cs-btn-clear cs-pd-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
          }, "뒤로가기")
        ])
      ])
    ])
  ]))
}